import React, {useEffect} from 'react';
import $ from "jquery";

function NewFreigabeAuftraggeberModalTable(props) {

    useEffect(() => {

        //initialize datatable
        $('#newAGTable').DataTable({
            dom: 'frtilp', language: {
                fontcolor: 'white', url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json' // German Language - DataTable Plugin
            }, oLanguage: {
                sSearch: '', searchPlaceholder: 'Suchen'
            }, "paging": true, "pageLength": 5
        });
    }, []);

    function addAG(id, firstName, lastName,role,entscheidungsbefugnis,email) {
        if ((props.auftraggeberReportData.find(item =>
            (item.firstName === firstName && item.lastName === lastName || item.Role===role)
        )===undefined)) {
if(entscheidungsbefugnis){entscheidungsbefugnis="yes"}
if(!entscheidungsbefugnis){entscheidungsbefugnis="No"}
if(role===undefined){role=""}
            let newAG = {
                "firstName": firstName,
                "lastName": lastName,
                "role":role,
                "entscheidungsbefugnis":entscheidungsbefugnis,
                "email":email
            }

            //props.setAuftraggeberReportData([...props.auftraggeberReportData, newAG])
            //props.auftraggeberReportData.push(newAG)
            props.setAuftraggeberReportData([newAG])
            props.auftraggeberReportData.length=0
            props.auftraggeberReportData.push(newAG)
            props.setIsChange(false)
            props.setShow(false)

        } else {
            alert("Auftraggeber bereits hinzugefügt");
        }
    }

    function getNewAGTableBody() {
         let result = props.projectIDData.filter(md =>
             props.auftraggeberReportData.every(fd => (fd.firstName !== md.firstName
                 && fd.lastName !== md.lastName)))

        //return props.projectIDData.map((item) => (<tr key={item.input_rank}
        return result.map((item) => (<tr key={item.input_rank}
                                                      onClick={() =>
                                                      {
                                                          addAG(item.input_rank, item.firstName, item.lastName,
                                                          item.role.label,item.entscheidungsbefugnis,item.email)
                                                      }
                                                      }
        >
            <td>{item.firstName}</td>
            <td>{item.lastName}</td>
            <td>{item.role.label}</td>

        </tr>))

    }

    return (
        <div>
            <table id="newAGTable" className="table handwai-white-text">
                <thead>
                <tr>
                    <th>Vorname</th>
                    <th>Nachname</th>
                    <th>Role</th>
                </tr>
                </thead>
                <tbody>{getNewAGTableBody()}</tbody>
            </table>
        </div>
    );
}

export default NewFreigabeAuftraggeberModalTable;
